import { useSelector } from 'react-redux';

import { setClass } from '../../helpers/utils';
import { LoadingSpinner } from '../LoadingSpinner';
import './styles.scss';

type LoadingGenericProps = { className?: string };

export const LoadingGeneric = ({ className = '' }: LoadingGenericProps) => {
	const { loading } = useSelector((state) => state.ui);

	return (
		<div
			className={setClass(
				`loading-generic ${loading.show && 'is-show'} ${className}`,
			)}
		>
			<LoadingSpinner variant="red" />
		</div>
	);
};
